<template>
  <analytics-sub-page
    v-if="tescoPortalStubsEnabled"
    title="Support Analytics"
    icon="life-ring"
    css-class="analytics-support"
    default-label="Support"
    :section-specs="sectionSpecs"
  >
    <support-metrics ref="supportRef" />
  </analytics-sub-page>
  <app-page v-else title="Page Not Found" icon="exclamation-triangle">
    <template #custom-content>
      <b-col>
        <div class="text-center mt-5">
          <h3>Page Not Available</h3>
          <p class="text-muted">This page is not available for your account.</p>
          <b-button variant="primary" to="/analytics">Go to Analytics</b-button>
        </div>
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import AppPage from '@/components/AppPage.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import SupportMetrics from '@/pages/analyticsApp/components/SupportMetrics.vue';

const { tescoPortalStubsEnabled } = useFeatureFlags();

const supportRef = ref(null);

const sectionSpecs = [{ key: 'support', label: 'Support', ref: supportRef }];
</script>
